import React from "react";
import Headers from "../Component/Headers";
import Subheader from "../Component/Subheader";
import Carousel from "react-bootstrap/Carousel";
import Categories from "../Component/Categories";
import NewArrival from "../Component/NewArrival";
import BestSellers from "../Component/BestSellers";
import TrendingProducts from "../Component/TrendingProducts";
import Footer from "../Component/Footer";
import "../styles/Header.css";
import "../styles/Home.css";
import imgcontainer from "../Assets/bannerimg.svg";

// Example images for carousel (replace with your own)
import slide1 from "../Assets/WEB COVER 2.png";
import slide2 from "../Assets/WEB COVER 3.png";
// import slide3 from "../Assets/Carosouel.svg";

function Home() {
  return (
    <div>
      {/* Main Header */}

      {/* Sub Header */}
      <Subheader />

      {/* Carousel Section */}
      <Carousel className="mt-3" controls indicators>
        <Carousel.Item>
          <div className="d-flex justify-content-center">
            <img
              className="d-block img-fluid w-100 hero-banner"
              src={slide1}
              alt="First slide"
            />
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="d-flex justify-content-center">
            <img
              className="d-block img-fluid w-100 hero-banner"
              src={slide2}
              alt="Second slide"
            />
          </div>
        </Carousel.Item>

        {/* <Carousel.Item>
          <div className="d-flex justify-content-center">
            <img
              className="d-block img-fluid w-100 hero-banner"
              src={slide3}
              alt="Third slide"
            />
          </div>
        </Carousel.Item> */}
      </Carousel>

      <Categories />
      <NewArrival />
      <BestSellers />
      <TrendingProducts />
     <img
  src={imgcontainer}
  className="img-fluid w-100 banner-img"
  alt="Banner"
/>

    </div>
  );
}

export default Home;
